<template>
    <p>sas</p>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({

    setup() {
        return {

        }
    }

})
</script>
    
<style lang="scss" scoped>
.tab-icon {
    width: 30px;
}
</style>



